import { plaintextValidator, urlValidator, dropdownValidator } from '../fields';
import { stringMandateConstraints } from '../utils';

const config = { mandatory: true };

const validateTrayIconName = {
  name: plaintextValidator(config)
};

const validateTrayIconStaticText = {
  name: plaintextValidator(config),
  toolTipText: plaintextValidator(config)
};

const validateTrayIconURL = {
  name: plaintextValidator(config),
  url: urlValidator(config)
};

const validateTrayIconExecuteCommand = {
  name: plaintextValidator(config),
  scripts: {
    array: {
      script: {
        presence: {
          allowEmpty: false,
          message: `Name can't be blank`
        }
      },
      arguments: {
        array: {
          value: stringMandateConstraints
        }
      }
    }
  }
};

export {
  validateTrayIconName,
  validateTrayIconURL,
  validateTrayIconStaticText,
  validateTrayIconExecuteCommand
};
